export const ACTION_PANEL_ACTION_BTN_TEST = 'dashboard-actions-panel-action-btn';

export const GROUP_SEARCH_MODAL_TEST = 'group-search-modal';
export const SEARCH_GROUP_NAME_INPUT = 'search-group-name-input';
export const SEARCH_GROUP_BTN = 'dashboard-search-group-btn';
export const EXISTING_GROUP_RECORD = 'existing-group-record';

export const CREATE_GROUP_FORM_ID = 'create-group-im-form';
export const CREATE_GROUP_MODAL_ACTION_BTN_TEST = 'create-group-modal-action-btn';

export const GROUP_TABLE_ROW_TEST = 'group-table-row';

export const DASHBOARD_NAME_CELL_TEST = 'dashboard-name-cell';
export const DASHBOARD_STAGE_CELL_TEST = 'dashboard-stage-cell';
export const DASHBOARD_ASSIGNED_CELL_TEST = 'dashboard-assigned-cell';
export const DASHBOARD_ACTIONS_DROPDOWN_TEST = 'dashboard-actions-dropdown';
export const REMOVE_GROUP_ACTION_BTN_TEST = 'remove-group-action-btn';
export const INBOUND_TAG_TEST = 'inbound-tag';

export const INBOUND_LEAD_FORM_ID = 'inbound-lead-form';
